<app-megamenu></app-megamenu>

<div class="pest-detail-page" *ngIf="pest">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="hero-background" [style.background-image]="'url(' + pest.image + ')'"></div>
    <div class="container">
      <div class="hero-content">
        <button mat-button class="back-button" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Back to Pest Library
        </button>
        <h1>{{ pest.name }}</h1>
        <p class="scientific-name">{{ pest.scientificName }}</p>
        <div class="danger-badge" [style.background-color]="getDangerColor(pest.dangerLevel)">
          {{ pest.dangerLevel }} Risk Level
        </div>
      </div>
    </div>
  </div>

  <!-- Overview Section -->
  <div class="overview-section">
    <div class="container">
      <div class="overview-grid">
        <div class="overview-content">
          <h2>Overview</h2>
          <p class="description">{{ pest.description }}</p>
          
          <div class="quick-facts">
            <div class="fact-item">
              <mat-icon>straighten</mat-icon>
              <div>
                <strong>Size:</strong>
                <span>{{ pest.size }}</span>
              </div>
            </div>
            <div class="fact-item">
              <mat-icon>restaurant</mat-icon>
              <div>
                <strong>Diet:</strong>
                <span>{{ pest.diet }}</span>
              </div>
            </div>
            <div class="fact-item">
              <mat-icon>schedule</mat-icon>
              <div>
                <strong>Lifecycle:</strong>
                <span>{{ pest.lifecycle }}</span>
              </div>
            </div>
            <div class="fact-item">
              <mat-icon>home</mat-icon>
              <div>
                <strong>Habitat:</strong>
                <span>{{ pest.habitat }}</span>
              </div>
            </div>
            <div class="fact-item">
              <mat-icon>calendar_today</mat-icon>
              <div>
                <strong>Season:</strong>
                <span>{{ pest.seasonality }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="overview-image">
          <img [src]="pest.image" [alt]="pest.name" />
        </div>
      </div>
    </div>
  </div>

  <!-- Information Sections -->
  <div class="info-sections">
    <div class="container">
      <div class="sections-grid">
        <!-- Identification -->
        <mat-card class="info-card">
          <mat-card-header>
            <mat-icon mat-card-avatar>search</mat-icon>
            <mat-card-title>Identification</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ul>
              <li *ngFor="let item of pest.identification">{{ item }}</li>
            </ul>
          </mat-card-content>
        </mat-card>

        <!-- Common Signs -->
        <mat-card class="info-card">
          <mat-card-header>
            <mat-icon mat-card-avatar>visibility</mat-icon>
            <mat-card-title>Common Signs</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ul>
              <li *ngFor="let sign of pest.commonSigns">{{ sign }}</li>
            </ul>
          </mat-card-content>
        </mat-card>

        <!-- Health Risks -->
        <mat-card class="info-card">
          <mat-card-header>
            <mat-icon mat-card-avatar>health_and_safety</mat-icon>
            <mat-card-title>Health Risks</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ul>
              <li *ngFor="let risk of pest.healthRisks">{{ risk }}</li>
            </ul>
          </mat-card-content>
        </mat-card>

        <!-- Prevention -->
        <mat-card class="info-card">
          <mat-card-header>
            <mat-icon mat-card-avatar>shield</mat-icon>
            <mat-card-title>Prevention Tips</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ul>
              <li *ngFor="let tip of pest.prevention">{{ tip }}</li>
            </ul>
          </mat-card-content>
        </mat-card>

        <!-- Treatment -->
        <mat-card class="info-card">
          <mat-card-header>
            <mat-icon mat-card-avatar>pest_control</mat-icon>
            <mat-card-title>Professional Treatment</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ul>
              <li *ngFor="let treatment of pest.treatment">{{ treatment }}</li>
            </ul>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="cta-section">
    <div class="container">
      <h2>Need Help with {{ pest.name }}?</h2>
      <p>Our pest control experts can eliminate {{ pest.name.toLowerCase() }} problems quickly and effectively.</p>
      <div class="cta-buttons">
        <button mat-raised-button class="primary-cta" routerLink="/contact">
          <mat-icon>request_quote</mat-icon>
          Get Free Quote
        </button>
        <button mat-button class="secondary-cta" routerLink="/services">
          <mat-icon>pest_control</mat-icon>
          View Services
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>